<template>
  <div>
    <FeaturedPostsComponent :featuredPosts="featuredPosts" />
    <LatestPostsComponent :posts="posts" :loadMorePosts="loadMorePosts" />
  </div>
</template>

<script>
import apolloClient from '@/services/apollo-client';
import { ref, onMounted, reactive } from 'vue';
import { useI18n } from 'vue-i18n';
import { GET_FEATURED_POSTS, GET_CURSOR_PAGINATED_POSTS } from '@/graphql/posts';
import FeaturedPostsComponent from '@/components/Posts/FeaturedPostsComponent.vue';
import LatestPostsComponent from '@/components/Posts/LatestPostsComponent.vue';

export default {
  name: 'HomePage',
  components: {
    FeaturedPostsComponent,
    LatestPostsComponent,
  },
  setup() {
    const postsPerPage = parseInt(process.env.VUE_APP_POSTS_PER_PAGE) || 12;
    const posts = reactive({ edges: [], pageInfo: { hasNextPage: false, endCursor: null } });
    const featuredPosts = ref([]);
    const loading = ref(false);
    const error = ref(null);
    const { t } = useI18n();

    const fetchPosts = async (first = postsPerPage, after = null, search = '') => {
      loading.value = true;
      try {
        const { data } = await apolloClient.query({
          query: GET_CURSOR_PAGINATED_POSTS,
          variables: { first, after, search },
        });

        if (after) {
          posts.edges = [...posts.edges, ...data.cursorPaginatedPosts.edges];
        } else {
          posts.edges = data.cursorPaginatedPosts.edges;
        }
        posts.pageInfo = data.cursorPaginatedPosts.pageInfo;
      } catch (err) {
        error.value = err;
        console.error('Error fetching posts:', err);
      } finally {
        loading.value = false;
      }
    };

    const fetchFeaturedPosts = async () => {
      loading.value = true;
      try {
        const { data } = await apolloClient.query({
          query: GET_FEATURED_POSTS,
        });
        featuredPosts.value = data.featuredPosts;
      } catch (err) {
        error.value = err;
        console.error('Error fetching featured posts:', err);
      } finally {
        loading.value = false;
      }
    };

    const loadMorePosts = async () => {
      if (posts.pageInfo.hasNextPage) {
        await fetchPosts(postsPerPage, posts.pageInfo.endCursor, searchQuery.value);
      }
    };

    const searchQuery = ref('');

    const parseSearchQuery = () => {
      const params = new URLSearchParams(window.location.search);
      searchQuery.value = params.get('s') || '';
    };

    onMounted(async () => {
      parseSearchQuery();
      await fetchFeaturedPosts();
      await fetchPosts(postsPerPage, null, searchQuery.value);
    });

    return {
      posts,
      featuredPosts,
      loadMorePosts,
      searchQuery,
      t,
    };
  },
};
</script>
